import React from 'react';
import { Box, CircularProgress, IconButton, Typography } from '@mui/material';
import Tooltip from '../lib/tooltip/Tooltip';

const DialogLoader = ({
	title,
	subtitle,
	loadingMessage,
	onClose,
}: {
	title: string;
	subtitle: string;
	onClose: (event: any) => void;
	loadingMessage?: string;
}) => (
	<div
		style={{
			display: 'flex',
			flexDirection: 'column',
			height: '100%',
			overflow: 'hidden',
			paddingBottom: 20,
		}}
	>
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
			}}
		>
			<div
				style={{
					padding: '40px 40px 0 40px',
					display: 'flex',
					alignItems: 'center',
					gap: '16px',
				}}
			>
				<IconButton
					id='definition-entity-dialog-back-arrow-button'
					className='dialog_back_button'
					onClick={onClose}
					style={{
						fontSize: 14,
						width: 22,
						height: 22,
						color: 'rgb(63, 63, 64)',
					}}
				>
					<i className='fa-solid fa-arrow-left' />
				</IconButton>
				<Tooltip
					anchorQuerySelector='#definition-entity-dialog-back-arrow-button'
					placement='bottom'
					openDelay={300}
				>
					Go back to the previous screen
				</Tooltip>
				<h1 style={{ margin: 0, fontWeight: 500, fontSize: '28px' }}>
					{title}
				</h1>
			</div>

			<p
				style={{
					margin: 0,
					color: 'rgba(0,0,0,0.54)',
					padding: '0px 40px 0 80px',
				}}
			>
				{subtitle}
			</p>
		</div>

		<Box
			sx={{
				display: 'flex',
				// flexGrow: 1,
				flexDirection: 'column',
				gap: 6,
				alignItems: 'center',
				height: 'calc(100% - 130px)',
				width: '100%',
				justifyContent: 'center',
			}}
		>
			<CircularProgress size={120} thickness={2} />

			<Typography variant='h6'>{loadingMessage || 'Loading project logic...'}</Typography>
		</Box>
	</div>
);

export default DialogLoader;
